import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-to-br from-primary-700 via-primary-600 to-primary-700 py-20">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute -top-16 -left-16 w-96 h-96 bg-white rounded-full blur-3xl" />
          <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-cyan-200 rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          

          <h1 className="font-heading text-5xl md:text-6xl font-bold tracking-tight text-white mb-4">
            About Us
          </h1>
          <p className="font-subheading text-xl text-blue-100 max-w-3xl mx-auto">
            Helpr helps small to midsize home service businesses capture more leads, respond faster, and book more jobs — day or night.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Our Story
              </h2>
              <p className="font-subheading text-lg text-gray-700 leading-relaxed">
                We exist to help home service business owners focus on what they do best, instead of chasing leads that slip away.
                We’ve seen firsthand how hard service pros work, only to lose jobs because of slow contact forms, missed calls, or after-hours inquiries.
                Helpr was born from the desire to bridge that gap.
              </p>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8">
              <h3 className="font-heading text-2xl font-semibold text-gray-900 mb-4">
                Why teams choose Helpr
              </h3>
              <ul className="space-y-3">
                <li className="font-subheading text-gray-700">Works on any website or platform</li>
                <li className="font-subheading text-gray-700">Customizable for different businesses</li>
                <li className="font-subheading text-gray-700">Automatic lead capture and organization</li>
                <li className="font-subheading text-gray-700">Mobile-responsive design</li>
                <li className="font-subheading text-gray-700">Zero technical setup required</li>
                <li className="font-subheading text-gray-700">Landing pages &amp; ad campaigns</li>
                <li className="font-subheading text-gray-700">Instant SMS notifications</li>
              </ul>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mt-8">
            <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
              <h2 className="font-heading text-3xl font-bold text-gray-900 mb-4">
                Our Mission
              </h2>
              <p className="font-subheading text-lg text-gray-700 leading-relaxed">
                Founded by two brothers and their best friend, we're on a mission to connect customers with great home service businesses — faster.
                Every quality service company deserves a steady pipeline of leads without the hassle of chasing them down.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
              <h2 className="font-heading text-3xl font-bold text-gray-900 mb-4">
                How It Works
              </h2>
              <p className="font-subheading text-lg text-gray-700 leading-relaxed">
                Our on-site assistant engages your website visitors in natural conversations, guiding them through your sales funnel while automatically capturing their contact information.
                The best part? It takes zero technical expertise from you. Check it out in the bottom left!
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
